
import { Box, Container } from "@mui/material";
import CardServices from "../cardServices";
import { useEffect, useState } from "react";
import api from "../../../services/api";
import RegisterAccess from '../../../utils/registerAccess';
import HeaderGestorConfigs from "../../../utils/headerGestorConfigs";


interface MenuState {
  analise: number;
  chefeArea: number;
  chefeDepartamento: number;
  directoraGeralAdjunta: number;
  directorGeral: number;

  quota: number;
  certificadosEmitidos: number;
  reprovado: number;
  reclamacoes: number;
}

type MenuProps = {
  styles: string,
  children?: React.ReactNode
}

export default function MenuDmtsCertificadoProdutoControlado({ styles, children }: MenuProps) {
  // const user = useSelector(state => state.account.user);

  const [menu, setMenu] = useState<MenuState>({
    analise: 0,
    chefeArea: 0,
    chefeDepartamento: 0,
    directoraGeralAdjunta: 0,
    directorGeral: 0,
    certificadosEmitidos: 0,
    reprovado: 0,
    reclamacoes: 0,
    quota: 0,

  })
  const [loadMenu, setLoadMenu] = useState<boolean>(true)


  useEffect(() => {
    api.get(`/menu/certificadoProdutoControlado`)
      .then(response => {
        setMenu(response.data);
      }).catch(error => {

      }).finally(() => setLoadMenu(false))

  }, [])

  return (
    <Container>
      <RegisterAccess page={'menu certificados para importacao de produto controlado'} />

      <Box className={styles}>
        <CardServices funcao='Técnico' load={loadMenu} count={menu.analise} icone={'/icones/Licenciamento.svg'} nomeService={'Solicitações de Certificado'} link={'/admin/dmts/solicitacoes-de-importacao/produtos/Controlados/Análise'} />
        <CardServices funcao='Técnico' load={loadMenu} count={menu.reprovado} icone={'/icones/solictacoesReprovadas.svg'} nomeService={'Solicitações Reprovadas'} link={'/admin/dmts/solicitacoes-de-importacao/produtos/Controlados/Reprovado'} />
        {/* <CardServices load={loadMenu} count={menu.quota} icone={''} nomeService={'Gestão de Quota'} link={'/admin/dmts/gest/quota'} /> */}
        {/* <CardServices load={loadMenu} count={menu.reclamacoes} icone={'/icones/Reclamacoes.svg'} nomeService={'Reclamações'} link={'/admin/reclamacoes?page=1'} /> */}
      </Box>


      <Box className={styles}>
        <CardServices funcao='Chefe de Área' load={loadMenu} count={menu.chefeArea} icone={'/icones/chefedaSeccao.svg'} nomeService={'Chefe de Área'} link={'/admin/dmts/solicitacoes-de-importacao/produtos/Controlados/Chefe de Área'} />
        <CardServices funcao='Chefe de Departamento' load={loadMenu} count={menu.chefeDepartamento} icone={'/icones/chefeDepartamento.svg'} nomeService={'Chefe de Departamento'} link={'/admin/dmts/solicitacoes-de-importacao/produtos/Controlados/Chefe de Departamento'} />
        <CardServices load={loadMenu} count={menu.directoraGeralAdjunta} icone={'/icones/chefedaSeccao.svg'} nomeService={'Directora Geral Adjunta Servicos Executivos'} link={'/admin/dmts/solicitacoes-de-importacao/produtos/Controlados/Directora Geral Adjunta para os Serviços Executivos'} />
        <CardServices funcao='Director Geral' load={loadMenu} count={menu.directorGeral} icone={'/icones/diretoraGeral.svg'} nomeService={'Diretor(a) Geral'} link={'/admin/dmts/solicitacoes-de-importacao/produtos/Controlados/Director Geral'} />
        <CardServices funcao='' load={loadMenu} count={menu.certificadosEmitidos} icone={'/icones/controleQualidade/certificadosAutorizacoes.svg'} nomeService={'Certificados Emitidos'} link={'/admin/dmts/solicitacoes-de-importacao/produtos/Controlados/Aprovado'} />
      </Box>

      <HeaderGestorConfigs title={'OUTROS SERVIÇOS'} />
      <Box className={styles}>


        {children}
      </Box>
    </Container>
  )
}





